import React from 'react';

/**
 * عرض قيمة مع نص بديل في حالة عدم وجود القيمة
 */
export function displayValue (value: string | null | undefined, fallback: string = 'غير محدد'): React.ReactNode {
  if (!value || value.trim() === '') {
    return <span className="text-gray-400">{fallback}</span>;
  }
  return value;
}

/**
 * عرض قيمة رقمية مع نص بديل
 */
export function displayNumber (value: number | null | undefined, fallback: string = '-'): React.ReactNode {
  if (value === null || value === undefined) {
    return <span className="text-gray-400">{fallback}</span>;
  }
  return value;
}

/**
 * عرض قائمة مع نص بديل في حالة عدم وجود عناصر
 */
export function displayList (items: any[] | null | undefined, fallback: string = 'لا توجد عناصر'): React.ReactNode {
  if (!items || items.length === 0) {
    return <span className="text-gray-400">{fallback}</span>;
  }
  return items;
}
